import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { GasConnectionResponse } from "../GasConnection.types";

export const gasConnectionQueries = {
  detail: (gasConnectionId?: number) =>
    queryOptions<GasConnectionResponse>({
      queryKey: ["gasConnection", { gasConnectionId }],
      queryFn: gasConnectionId
        ? () => fetchGasConnection(gasConnectionId)
        : skipToken,
      enabled: typeof gasConnectionId !== "undefined",
      refetchInterval: false,
      refetchOnWindowFocus: false
    })
};

export function useGasConnection(gasConnectionId?: number) {
  return useQuery(gasConnectionQueries.detail(gasConnectionId));
}

async function fetchGasConnection(gasConnectionId: number) {
  const response = await apiWithoutCamelization.get<GasConnectionResponse>(
    urls.apiWithoutCamelization.gasConnection(gasConnectionId)
  );
  return response.data;
}
